import styled from "styled-components";

export default styled.ul`
  list-style: disc;
  padding-left: 2rem;

  > li {
    padding-bottom: 0.4rem;
    font-size: 0.8rem;
    line-height: 1rem;
  }
`;
